import { apiRoutes } from '../../../api-routes';
import { baseUrl } from '../../../constants';
import { type AxiosRequestConfig, publicHttpClient } from '../../../util';
import type { GetListTrackingPortalOrderParams } from '../get-list-tracking-portal-order-fn';
import type { TrackingPortalOrder } from '../type';

export async function getInternalTrackingListFn(
  params: GetListTrackingPortalOrderParams,
  config: Omit<AxiosRequestConfig, 'params'> = {}
) {
  const response = await publicHttpClient.get<{
    data: TrackingPortalOrder[];
    total: number;
  }>(baseUrl + apiRoutes.tracking.internal.orderList, {
    params,
    ...config,
    withCredentials: true,
  });

  return response.data;
}
